import { getApiBase } from './serverConfig';

/**
 * The address a photograph can actually be loaded from, by THIS client.
 *
 * In the cloud a photo's s3_url is an S3 URL and needs nothing. On the desktop
 * the storage backend writes it absolute, with the address the desktop server
 * had at upload time -- http://127.0.0.1:8787/objects/... On that computer it
 * loads. Everywhere else it names the wrong machine: a phone on the LAN, the
 * native app, or any client pointed at the laptop by its network address would
 * ask ITSELF for the file, and every thumbnail renders as a broken image.
 *
 * So a loopback object URL is re-based onto the server this client is really
 * talking to (utils/serverConfig), and everything else is returned untouched.
 * Nothing is rewritten in the database: the stored key layout is shared with
 * the cloud on purpose, and only the prefix is local.
 */
const LOCAL_OBJECT = /^https?:\/\/(?:127(?:\.\d{1,3}){3}|localhost|\[::1\])(?::\d+)?(\/objects\/\S+)$/i;

/** The origin that serves /objects for the given API base; '' = this page's own. */
export function objectOrigin(apiBase = getApiBase()) {
  const base = String(apiBase || '').replace(/\/+$/, '');
  if (!base || base.startsWith('/')) return '';
  try {
    return new URL(base).origin;
  } catch (e) {
    return '';
  }
}

export function resolvePhotoUrl(url, apiBase) {
  if (!url) return '';
  const match = LOCAL_OBJECT.exec(String(url).trim());
  if (!match) return url;
  return `${objectOrigin(apiBase === undefined ? getApiBase() : apiBase)}${match[1]}`;
}
